import { render, staticRenderFns } from "./ruleModal.vue?vue&type=template&id=ece4f2b2&scoped=true&"
import script from "./ruleModal.vue?vue&type=script&lang=js&"
export * from "./ruleModal.vue?vue&type=script&lang=js&"
import style0 from "./ruleModal.vue?vue&type=style&index=0&id=ece4f2b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece4f2b2",
  null
  
)

export default component.exports